import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from 'src/app/services/account.service';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  user: User = new User("","","","","","");
  title: string;
  private wasLoggedIn?: boolean;

  constructor(private accountService: AccountService, private router: Router, private translate: TranslateService) {
    this.title = 'ecrf-frontend';
    this.translate.setDefaultLang('en');
    this.accountService.user.subscribe(x => {
      this.user = x;
      this.applyLanguage();
    });
  }

  // Public pages (login, password recovery) have no language selector, so they are always shown in English.
  // Once logged in, AppLayout applies the browser language and the user can change it from the menu.
  private applyLanguage() {
    const isLoggedIn = this.loggedIn();
    if (isLoggedIn === this.wasLoggedIn) {
      return;
    }
    this.wasLoggedIn = isLoggedIn;
    if (!isLoggedIn) {
      this.translate.use('en');
    }
  }

  loggedIn() {
    if (this.user.username)
      return true;
    return false
  }
}
